import Info from "../pages/Info";
import StudentLogin from "../pages/StudentLogin";
import AdminLogin from "../pages/AdminLogin";
import Main from "../pages/Main";
import AnketView from "../pages/AnketView";
import QuestionPage from "../pages/QuestionPage";
import AdminPage from "../pages/AdminPage";

export const privateStudentRoutes = [
    {path: '/student/anket', element: <AnketView />, exact: true},
    {path: '/student/question/:number', element: <QuestionPage />, exact: true}   
]

export const privateAdminRoutes = [
    {path: '/admin', element: <AdminPage />, exact: true},
]

export const publicRoutes = [
    {path: '/', element: <Main />, exact: true},
    {path: '/information', element: <Info />, exact: true},
    {path: '/student/login', element: <StudentLogin />, exact: true},
    {path: '/admin/login', element: <AdminLogin />, exact: true}
]